import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ClientConfigClass;
function ClientConfig() {
  if (ClientConfigClass === VOID) {
    class $ {
      constructor(prereleaseMode, auth0ClientId, auth0Domain, basename, expressEnv, webpackPublicPath, websocketHost) {
        this.b7e_1 = prereleaseMode;
        this.c7e_1 = auth0ClientId;
        this.d7e_1 = auth0Domain;
        this.e7e_1 = basename;
        this.f7e_1 = expressEnv;
        this.g7e_1 = webpackPublicPath;
        this.h7e_1 = websocketHost;
      }
      toString() {
        return 'ClientConfig(prereleaseMode=' + this.b7e_1 + ', auth0ClientId=' + this.c7e_1 + ', auth0Domain=' + this.d7e_1 + ', basename=' + this.e7e_1 + ', expressEnv=' + this.f7e_1 + ', webpackPublicPath=' + this.g7e_1 + ', websocketHost=' + this.h7e_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.b7e_1);
        result = imul(result, 31) + getStringHashCode(this.c7e_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.d7e_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e7e_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.f7e_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g7e_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h7e_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConfig()))
          return false;
        if (!(this.b7e_1 === other.b7e_1))
          return false;
        if (!(this.c7e_1 === other.c7e_1))
          return false;
        if (!(this.d7e_1 === other.d7e_1))
          return false;
        if (!(this.e7e_1 === other.e7e_1))
          return false;
        if (!(this.f7e_1 === other.f7e_1))
          return false;
        if (!(this.g7e_1 === other.g7e_1))
          return false;
        if (!(this.h7e_1 === other.h7e_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConfig');
    ClientConfigClass = $;
  }
  return ClientConfigClass;
}
//region block: exports
export {
  ClientConfig as ClientConfig2mpft8d5d0hh3,
};
//endregion

//# sourceMappingURL=ClientConfig.mjs.map
